module.exports = __webpack_public_path__ + "img/handshake-angle.8eae82da.svg";